import styled from 'styled-components';

export const ForaBuffet = styled.section`
  width: 1500px;
  margin: 0 auto;
  display: flex;
  padding-top: 20px;

  @media (max-width: 1550px) {
    width: 1099px;
    padding-top: 25px;
  }

  @media (max-width: 1130px) {
    width: 800px;
  }

  @media (max-width: 850px) {
    flex-wrap: wrap;
    width: 95%;
    margin: unset;
    float: right;
  }
`;

export const ForaImagemBuffet = styled.div`
  width: 50%;

  @media (max-width: 850px) {
    margin-top: 15px;
    width: 95%;
    margin: 0 auto;
    margin-left: 0px;
  }
`;

export const ImagemBuffet = styled.img`
  width: 100%;
  height: auto;
`;

export const DirBuffet = styled.div`
  width: 50%;

  @media (max-width: 850px) {
    width: 95%;
    margin: 0 auto;
    margin-left: 0px;
  }
`;

export const ForaTextBuffet = styled.div`
  @media (max-width: 850px) {
    display: none;
  }
`;

export const ForaTextBuffetResp = styled.div`
  display: none;

  @media (max-width: 850px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 20px;
  }
`;

export const DentroForaTextBuffet = styled.div``;

export const TextBuffet1 = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 40px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.secondary};
  text-transform: uppercase;
  padding-left: 12%;

  span {
    color: ${({ theme }) => theme.color.primary};
  }

  @media (max-width: 1550px) {
    font-size: 30px;
    padding-left: 8%;
  }

  @media (max-width: 850px) {
    width: 301px;
    font-size: 26px;
    padding-left: 0%;
    line-height: 46px;
  }

  @media (max-width: 520px) {
    width: 236px;
    font-size: 36px;
    padding-left: 0%;
    line-height: 36px;
  }

  @media (max-width: 420px) {
    width: 219px;
    font-size: 23px;
    padding-left: 0%;
    line-height: 36px;
  }
`;

export const ImagemRiscoVermelho2 = styled.img`
  margin-top: 35px;

  @media (max-width: 1550px) {
    margin-top: 15px;
  }

  @media (max-width: 850px) {
    width: 168px;
    height: 8px;
    margin-left: 19px;
    margin-top: 42px;
  }

  @media (max-width: 520px) {
    width: 140px;
    height: 6px;
    margin-left: 19px;
    margin-top: 37px;
  }

  @media (max-width: 420px) {
    width: 85px;
    height: 3px;
  }
`;

export const TextBuffet2 = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: #3d3d3d;
  padding-left: 12%;
  padding-top: 35px;
  line-height: 28px;

  @media (max-width: 1550px) {
    font-size: 19px;
    padding-top: 15px;
    line-height: 24px;
    padding-left: 8%;
  }

  @media (max-width: 850px) {
    padding-left: 0%;
    padding-top: 20px;
  }
`;

export const TextSaloes = styled.h3`
  font-family: 'Rubik', sans-serif;
  font-size: 50px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.primary};
  text-transform: uppercase;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 80px;

  @media (max-width: 1100px) {
    padding-top: 75px;
    padding-bottom: 60px;
  }

  @media (max-width: 480px) {
    font-size: 30px;
    padding-top: 50px;
    padding-bottom: 0px;
  }
`;